module.exports = __webpack_public_path__ + "static/media/hub-blue.b4054a3d.svg";